export enum TranslationsLanguage {
    English = "English",
    Chinese = "Chinese"
}

export function languageName(language: TranslationsLanguage): string {
    switch (language) {
        case TranslationsLanguage.English:
            return "English";
        case TranslationsLanguage.Chinese:
            return "中文";
    }
}

export function languageClass(language: TranslationsLanguage): string {
    switch (language) {
        case TranslationsLanguage.English:
            return "english-language";
        case TranslationsLanguage.Chinese:
            return "chinese-language";
    }
}

export function languageCode(language: TranslationsLanguage): string {
    switch (language) {
        case TranslationsLanguage.English:
            return "en";
        case TranslationsLanguage.Chinese:
            return "zh";
    }
}

export function languageLocale(language: TranslationsLanguage): string {
    switch (language) {
        case TranslationsLanguage.English:
            return "en-AU";
        case TranslationsLanguage.Chinese:
            return "zh";
    }
}